module.exports = __webpack_public_path__ + "static/media/DSC_0871.a9bdc09d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0871.jpg
// module id = 608
// module chunks = 0